import { render, staticRenderFns } from "./VasionEditableTable.vue?vue&type=template&id=391954d8&scoped=true"
import script from "./VasionEditableTable.vue?vue&type=script&lang=js"
export * from "./VasionEditableTable.vue?vue&type=script&lang=js"
import style0 from "./VasionEditableTable.vue?vue&type=style&index=0&id=391954d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391954d8",
  null
  
)

export default component.exports